import {testSpeed} from '../../lib/connectionSpeed'

export default {
  namespaced: true,
  state: {
    active: false,
    complete: false,
    step: '',
    progress: 0,
    uploadSpeed: 0,
    downloadSpeed: 0,
    passed: false,
    lastRunAt: null
  },
  mutations: {
    clear(state){
      state.active=false;
      state.complete=false;
      state.passed=false;
      state.progress=0;
      state.uploadSpeed=0;
      state.downloadSpeed=0;
      state.step='';
    },
    setActive(state, active){
      state.active=active;
    },
    setComplete(state, passed){
      state.active=false;
      state.complete=true;
      state.passed=passed;
      state.lastRunAt=Date.now();
    },
    setProgress(state, progress){
      state.progress=progress;
    },
    setUploadSpeed(state, speed){
      state.uploadSpeed=speed;
    },
    setDownloadSpeed(state, speed){
      state.downloadSpeed=speed;
    },
    overridePassed(state, passed){
      state.passed=passed;
    },
  },
  actions: {
    accept({commit}){
      commit('overridePassed',true);
    },
    start({state,commit,dispatch}){
      if(!state.passed && !state.active){
        commit('setActive',true);
        testSpeed((p)=>{
          commit('setProgress',p);
        }).then((result)=>{
           commit('setUploadSpeed',result.upload);
           commit('setDownloadSpeed',result.download);
           dispatch('complete');
        });
      }
    },
    complete({commit,state}){
      if(state.uploadSpeed >= 0.1 && state.downloadSpeed >= 0.4){
        commit('setComplete',true);
      }else{
        commit('setComplete',false);
      }
    },
    reset({commit}){
      commit('clear');
    },
    rerun({commit, dispatch}){
      commit('clear');
      dispatch('start');
    }
  },
  getters: {}
}